import { render, staticRenderFns } from "./PageLogging.vue?vue&type=template&id=7983997e&"
import script from "./PageLogging.vue?vue&type=script&lang=js&"
export * from "./PageLogging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports